import React from 'react';
import Navigation from './Navigation';
import fountain from '../images/fountain.jpg';
import hug from '../images/hug1.jpg';
import header_two_ham from '../images/header_two_ham.png';
import Helmet from "react-helmet";

const About = () => (
  <div className="full-job-ctn">
    <Helmet>
      <title>Hamilton Homes - The Prosession Team is ready for you</title>
      <meta name="description" content="We offer the most detail, geopgraphically specific, updated search for properties in the GTHA!"/>
      <meta name="keywords" content="hamilton,homes,for,sale,niburski,search,condos,luxury,business"/>

      <meta property="og:url" content="https://besthamiltonhouses.com/about"/>
      <meta property="og:title" content="Hamilton Homes - About"/>
      <meta property="og:description" content="We offer the most detail, geopgraphically specific, updated search for properties in the GTHA!"/>
    </Helmet>

    <div className="job-outline">
      <div className="full-job-details-stacked listing-page">
        <img src={header_two_ham} />
        <div className="heading">
          <h2>Hamilton's RealEstate Agents</h2>
        </div>

        <div className="split">
          <div className="left">
            <img src={hug} />
          </div>

          <div className="right">
            The best realtors ever.

            <ul>
              <li>Number one in sales</li>
              <li>Number one in buys</li>
              <li>Number one in custom sites</li>
            </ul>
          </div>
        </div>

        <br/>
        <br/>
        <br/>
      </div>
    </div>
  </div>
);

export default About;
